import React from 'react';

function Galleries() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <path fill="currentColor" d="M18 0a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-1v1.11A1.89 1.89 0 0 1 15.11 20H1.89A1.89 1.89 0 0 1 0 18.11V4.89A1.89 1.89 0 0 1 1.89 3H3V2a2 2 0 0 1 2-2h13zM4 2v12.42l4.42-3.77a2.49 2.49 0 0 1 3.11-.09l1.34 1a1.51 1.51 0 0 0 2-.14L19 7.29V2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1zm12 16.11V17H5a2 2 0 0 1-2-2V4H1.89a.89.89 0 0 0-.89.89v13.22c0 .492.398.89.89.89h13.22a.89.89 0 0 0 .89-.89zM18 16a1 1 0 0 0 1-1V8.71l-3.39 3.42a2.51 2.51 0 0 1-3.27.23l-1.34-1a1.49 1.49 0 0 0-1.89.05L4.2 15.56A1 1 0 0 0 5 16h13zM8.25 7.75a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5zm0-3.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5z" />
    </svg>
  );
}

export default Galleries;
